import { styled } from '@styledComponents';
import { animationTransition } from '@utils/animationTransition';
import { BaseImage } from '@components/CloudImage';
import { Button } from '@components/Button';

export const ECardWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const ECardImageWrapper = styled.div<{ aspectRatio: number }>`
  position: relative;
  width: ${({ aspectRatio }) => (isImageSquarish(aspectRatio) ? '80%' : aspectRatio > 1 ? '100%' : 'unset')};
  height: ${({ aspectRatio }) => (isImageSquarish(aspectRatio) ? '80%' : aspectRatio < 1 ? '100%' : 'unset')};
`;

const isImageSquarish = (aspectRatio: number) => {
  return aspectRatio >= 0.9 && aspectRatio <= 1.1;
};

export const ECardImage = styled(BaseImage)<{ $isLoaded: boolean; $isHovered?: boolean }>`
  max-width: 100%;
  max-height: 100%;
  visibility: ${({ $isLoaded }) => ($isLoaded ? 'visible' : 'hidden')};
  box-shadow: ${({ $isHovered }) =>
    $isHovered
      ? '0px 30px 60px -12px rgba(68, 50, 93, 0.25), 0px 18px 36px -18px rgba(0, 0, 0, 0.3)'
      : '0px 4px 12px -2px rgba(68, 50, 93, 0.25), 0px 2px 7px -3px rgba(0, 0, 0, 0.3)'};

  transition: ${animationTransition('box-shadow')};
  display: block;
`;

export const ECardHoverOverlay = styled.div<{ isHovered: boolean }>`
  display: none;
  @media (hover: hover) {
    display: block;
    opacity: ${({ isHovered }) => (isHovered ? 1 : 0)};
    background: rgba(255, 255, 255, 0.64);
    transition: ${animationTransition('opacity')};
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    ${Button} {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
`;
